// extracted by mini-css-extract-plugin
module.exports = {"point":"point-3cEbi","time":"time-3I7Zd","point_thin":"point_thin-2z9sk","date__container":"date__container-CBIn8","date":"date-26M9K"};